import { Model } from "@type-r/models";
import {  define } from "@type-r/models";
import { restfulIO } from "api/endpoint";
@define
export class ReportList extends Model {

    static endpoint = restfulIO('api/bi/GetInblockReports');

    static attributes = {
        id: String,
        powerbiname: String,
        displayName: String,
        description: String,
    }
}


